import { render, staticRenderFns } from "./veStuEvaluationConfig.vue?vue&type=template&id=02244e80&scoped=true"
import script from "./veStuEvaluationConfig.vue?vue&type=script&lang=js"
export * from "./veStuEvaluationConfig.vue?vue&type=script&lang=js"
import style0 from "./veStuEvaluationConfig.vue?vue&type=style&index=0&id=02244e80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02244e80",
  null
  
)

export default component.exports